<footer class="footer ">
    <div class="container-fluid">
        <nav class="pull-left">
            <ul>
                <li>
                    <a href="#">
                        PRAMAT
                    </a>
                </li>
            </ul>
        </nav>
        <!-- <div class="copyright pull-right">
            &copy;
            {{test | date: 'yyyy'}}, All Rights Reserved to
            <a href="#" target="_blank">PRAMAT Fintech Pvt. Ltd</a>.
        </div> -->
    </div>
</footer>
